import Cookies from "js-cookie";
import { decryptData } from "utils/crypto";

const roleId = Number(decryptData(Cookies.get("role_id")));

export const wfhSteps = ()=>{
  const roleId = Number(decryptData(Cookies.get("role_id")));
  return[
  {
    target: '[data-tour="wfh-module"]',
    title: '🏠 Work From Home Module',
    content:
      'Here you can apply for WFH requests or manage employee WFH records based on your role.',
    disableBeacon: true,
  },

  ...(roleId === 1 || roleId === 2
    ? [
        {
          target: '[data-tour="wfh-logs-tab"]',
          title: '📊 WFH Logs',
          content:
            'Admins can view and manage all employee WFH requests here.',
          disableBeacon: true,
        },
      ]
    : [
        {
          target: '[data-tour="wfh-apply-tab"]',
          title: '📝 Apply WFH',
          content:
            'Submit your Work From Home request by selecting dates and reason.',
          disableBeacon: true,
        },
      ]),
];
}